import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePanelAuth } from "@/panel/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = usePanelAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#141312]" data-testid="panel-loading">
        <Loader2 className="h-7 w-7 animate-spin text-[#c9a86e]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/bird" replace />;
  return children;
}
